import baseTheme from 'gatsby-theme-docz/src/theme/index'
import { merge } from 'lodash/fp'

export default merge(baseTheme, {
  // here you can style this app following the guide
  // colors:{
  //   background:'red'
  // }
})